import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoginResponse } from "../types";
import { ServerRoutes } from "../routes";
import logo from "../assets/logo.png";

export default function LoginPage() {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Please enter both email and password.");
      return;
    }

    try {
      const response = await axios.post<LoginResponse>(
        ServerRoutes.login,
        { username, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;

      setError("");
      await localStorage.setItem("token", data.tokens.accessToken);
      setTimeout(() => {
        navigate("/");
      }, 500);      
    } catch (err: any) {
      const message =
        err.response?.data?.message || err.message || "Login failed.";
      setError(message);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#0B2038",
        backgroundImage:
          "radial-gradient(circle at 50% 0%, #123761 0%, #0B2038 60%)",
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: "100%",
          border: "none",
          boxShadow: "0 24px 64px rgba(0,0,0,0.35)",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box
            component="img"
            src={logo}
            alt="Amoozical"
            sx={{
              width: 56,
              height: 56,
              borderRadius: "14px",
              display: "block",
              mx: "auto",
              mb: 2,
              objectFit: "cover",
            }}
          />
          <Typography
            variant="h5"
            component="h1"
            align="center"
            sx={{ fontWeight: 700 }}
          >
            Welcome back
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ mb: 3 }}
          >
            Sign in to the Amoozical backoffice
          </Typography>
          <Box
            component="form"
            onSubmit={handleLogin}
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            <TextField
              type="text"
              label="Email"
              variant="outlined"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              type="password"
              label="Password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              sx={{ mt: 1 }}
            >
              Sign In
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
